import React,{useEffect} from 'react';
import {btnSetColor_CBack,TableDatePicker} from '../../function_lib/common_lib';
import {Custom_Alert,Alert_Content} from '../../components/custom_alert';
export function Comp_Add_Engine_Room_Watched(props){
    const saveEngineRoomWatchesRec=()=>{
        btnSetColor_CBack(this,"frmEngineRoomWatched","addEngineRoomWatchesRecord",function(data,msg){
            Custom_Alert("View",msg,false);
        })
      }

  //alert(JSON.stringify(props.editUser));
   useEffect(()=>{

   },[props.editUser]);
  
    return(<div className="modal fade bd-example-modal-xl"  id="divAddEngineRoomWatcRec" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-xl" role="document">
      <div className="modal-content">
      <div className="modal-header bg-primary">
          <h5 className="modal-title text-white" id="exampleModalLabel">Engine Room Watched</h5>
          <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" className="text-white">&times;</span>
          </button>
        </div>
        <form id="frmEngineRoomWatched" name="frmEngineRoomWatched">
        <input type="hidden" id="m_type" name="m_type" value={"addEngineRoomWatchesRecord"}/>
        <input type="hidden" id="res_func" name="res_func" value={"useit"}/>
            <input type="hidden" id="global_token" name="global_token" value={props.logUser[0]["app_user_id"]}/>
            <input type="hidden" id="local_token" name="local_token" value={props.logUser[0]["id"]}/>
       
        <div className="modal-body">
             {/* form content  */}
             <div class="container engine-room-watchess text-start">
    <h2 class="text-center mb-4">Record of Engine Room watches Form</h2>
    
        <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>Ship Name:</strong></label>
                <input name="ship_name" id="ship_name" type="text" class="form-control" placeholder="Enter ship name" required/>
            </div>
            <div class="col-md-6 form-group">
                <label><strong>IMO Number:</strong></label>
                <input name="imo_no" id="imo_no" type="text" class="form-control" placeholder="Enter imo number" required/>
            </div>
        </div>
        
        <div class="row">
           
        <div class="col-md-6 form-group">
                <label><strong>Capacity:</strong></label>
                <input name="capacity" id="capacity" type="text" class="form-control" placeholder="Enter capacity" required/>
            </div>
            <div class="col-md-6 form-group">
                <label><strong>Call Sign:</strong></label>
                <input name="call_sign" id="call_sign" type="text" class="form-control" placeholder="Enter capacity" required/>
            </div>
            <div class="col-md-6 form-group">
                <label><strong>Ship Type:</strong></label>
                <input name="ship_type" id="ship_type" type="text" class="form-control" placeholder="Enter capacity" required/>
            </div>
        </div>

         <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>Date:</strong></label>
                <div className="input-group input-group-sm">
                  <TableDatePicker refName="engine_room_date" />
                </div>
                {/* <input name="engine_room_date" id="engine_room_date" type="text" class="form-control" required/> */}
            </div>
            <div class="col-md-6 form-group">
                <label><strong>Time From:</strong></label>
                <input name="time_from" id="time_from" type="time" class="form-control" required/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>Time To:</strong></label>
                <input name="time_to" id="time_to" type="time" class="form-control" required/>
            </div>
            <div class="col-md-6 form-group">
                <label><strong>Voyage Number:</strong></label>
                <input name="voyage_number" id="voyage_number" type="text" class="form-control" placeholder="Enter voyage number" required/>
            </div>
        </div>

          <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>Voyage: <br/>Departure Port</strong></label>
                <input name="voyage_depart_port" id="voyage_depart_port" type="text" class="form-control required" required/>
            </div>
              <div class="col-md-6 form-group">
                <label><strong>Voyage: <br/>Arrival Port</strong></label>
                <input name="voyage_arrival_port" id="voyage_arrival_port" type="text" class="form-control required" required/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>Type of watch:<br/> (At sea /At Anchor)</strong></label>
                <select id="type_of_watches" name="type_of_watches" class="form-control required">
                    <option value={"0"}>-Select-</option>
                    <option value={"At sea"}>At sea</option>
                    <option value={"At anchor"}>At anchor</option>

                </select>
                {/* <input name="types_of_watch" type="text" class="form-control" placeholder='Enter type of watch' required/> */}
            </div>
            <div class="col-md-6 form-group">
                <label><strong>Remarks <br/> (describe watch activities) *:</strong></label>
                <textarea id="remarks" name="remarks" class="form-control required">

                </textarea>
                
            </div>
        </div>

       {/* <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>Signature of Engineer officer of watch </strong></label>
                <input name="engineer_officer_of_watch_signature" type="text" class="form-control" required/>
            </div>
       </div> */}

       
    
</div>
             {/* end of form contacnt */}
        </div>
        <div className="modal-footer">
        <div id="getReponse" style={{color:"red"}}></div>
          <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" data-dismiss="modal">Close</button>
          <button type="button" onClick={()=>saveEngineRoomWatchesRec()} className="btn btn-primary">Save</button>
        </div>
        </form>
      </div>
      </div>
      </div>)
}

export default Comp_Add_Engine_Room_Watched;